exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-wrapper[data-v-a0d86702] {\n  display: block;\n  overflow: hidden;\n}\n.field-wrapper label[data-v-a0d86702] {\n  display: block;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n}", ""]);

// exports
